import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'ng-zorro-antd/core/util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CurrentAffair } from 'src/app/core/interfaces/current-affair';
import { Testimonial } from 'src/app/core/interfaces/testimonial';
import { HttpRequestService, LocalStorageService } from 'src/app/core/services';
import { CommonService } from 'src/app/core/services/common.service';
import { RejectionReasonComponent } from 'src/app/shared/components/rejection-reason/rejection-reason.component';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
})
export class TestimonialsComponent implements OnInit {
  allTestimonials: Testimonial[] = [];
  allApprovedTestimonials: Testimonial[] = [];
  isAddOrUpdate: boolean = true;
  totalDataCount = 0;
  totalApprovedDataCount = 0;
  pageSize = 12;
  pageIndex = 1;
  loading = false;
  searchTestimonial: Subject<string> = new Subject<string>();
  search = '';
  userRole: string = '';
  subAdminAddedAffairs: CurrentAffair[] = [];
  index : number = 0;
  skipIndex : number = 0;
  snapShootIndex : number = 0;
  // listView = true;
  // isOpenDetails = false;
  // active: boolean = false;
  // deActive: boolean = true;
  // isSubjectComponent: boolean = true;

  constructor(
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private modalService: NzModalService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.snapShootIndex = toNumber(this.activatedRoute.snapshot.queryParams.index) ;
    if(this.snapShootIndex){
      this.changeIndex(this.snapShootIndex)
    }
    this.userRole = this.localStorageService.getItem('user').role;
  }

  // on page load functions
  ngOnInit(): void {
    this.searchTestimonial
      .pipe(debounceTime(1000))
      .subscribe((success: string) => {
        this.search = success;
        this.getAllTestimonials(this.index);
      });
  }
  changeIndex(data: any) {
    this.router.navigate([], { queryParams: {index: data } });
    this.pageIndex = 1;
    this.pageSize = 12;
    this.allApprovedTestimonials = [];
    this.allTestimonials = [];
    this.index = data
    this.getAllTestimonials();
  }

  /* Get all subjects */
  getAllTestimonials(index: number = 0, skip = 0, sortBy?: any): void {
    index = index? index : this.index
    let params: any;
    params = { skip: this.skipIndex, limit: this.pageSize };
    if (this.search) {
      params.search = this.search;
    }
    if (sortBy) {
      params.sortBy = JSON.stringify(sortBy);
    }
    if (index === 0) {
      params.approveStatus = 'approved';
    } else if (index === 1 && this.userRole === 'admin') {
      params.approveStatus = 'pending';
    } else if (index === 1 && this.userRole === 'subAdmin') {
      params.approveStatus = ['pending', 'rejected'];
    } else {
      delete params.approvedStatus;
    }
    this.loading = true;
    this.httpRequestService.request('get', 'testimonials', params).subscribe(
      (result) => {
        this.loading = false;
        const data: Testimonial[] = result.data;
        if (index === 0) {
          this.allApprovedTestimonials = data;
          this.totalApprovedDataCount = result.totalCount;
        } else {
          this.allTestimonials = data;
          this.totalDataCount = result.totalCount;
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  /* For Pagination / Sending skip */
  onQueryParamsChange(params: NzTableQueryParams): void {
    this.allApprovedTestimonials = [];
    this.allTestimonials = [];
    const { pageSize, pageIndex } = params;
    this.skipIndex = pageSize * (pageIndex - 1)
    this.getAllTestimonials(this.index, pageSize * (pageIndex - 1));
  }


  /* Status change*/
  updateStatus(id: string, status: boolean): void {
    this.httpRequestService
      .request('put', `testimonials/active-inactive/${id}`, { status: !status })
      .subscribe((result: any) => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAllTestimonials(this.index);
      });
  }
  updatePendingStatus(id: string, pendingStatus: string) {
    this.httpRequestService
      .request('put', `testimonials/approved-rejected/${id}`, {
        approveStatus: 'approved',
      })
      .subscribe((result: any) => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAllTestimonials(this.index);
      });
  }
  openRejectionReason(id: string, pendingStatus: string) {
    const rejectionReason = this.modalService.create({
      nzTitle: 'Add A Reason',
      nzContent: RejectionReasonComponent,
      nzWidth: '800px',
      nzFooter: null,
      nzComponentParams: {
        updateId: id,
        component: 'testimonials',
      },
      nzCancelText: null,
      nzOkText: null,
    });

    const questionService = rejectionReason.afterClose.subscribe(
      (data: any) => {
        this.getAllTestimonials(this.index);
      }
    );
  }
  deleteTestimonial(id: any) {
    this.httpRequestService
      .request('delete', `testimonials/${id}`)
      .subscribe((result: any) => {
        this.notificationService.success(
          '',
          'Testimonial Deleted Successfully'
        );
        this.getAllTestimonials(this.index);
      });
  }
  // Search affairs
  searchTestimonials(event: any): void {
    this.searchTestimonial.next(event);
  }
}
